<template>
  <div class="converter">
    <!-- <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
     
    </a-upload> -->
    <template v-if="uploading">
      <logger @end="endHandler" />
      <a-button v-if="isShowDownloadBtn" class="download-btn" block size="large" type="primary"
        @click="downloadModel">Download Model</a-button>
    </template>
    <template v-else>

      <button type="button" class="formula-btn" @click="showModal">
        <span class="material-symbols-outlined">functions</span>
      </button>

      <div>
        <a-modal v-model="isModalVisible" 
        title="Converter details:" 
        @ok="closeModal" 
        :bodyStyle="{height: '450px', overflow: 'auto'}"
        
        >
        <template slot="footer">
        <a-button key="back" type="primary" @click="closeModal">
          OK
        </a-button>
      </template>
          <div v-if="engineInfo">
            Engine version: {{ engineInfo.engineVersion }} <br>
            Extractor version: {{ engineInfo.extractorVersion }} <br>
            API version: {{ engineInfo.apiVersion }} <br>
            UI version: {{ engineInfo.uiVersion }} <br>
            <br>
            List of supported functions: <br>
            <ul>
              <li v-for="(func, index) in engineInfo.supportedFuncs" :key="index">
                {{ func }}
              </li>
            </ul>
          </div>
          <div v-else>
            Loading...
          </div>
        </a-modal>
      </div>

      <a-alert v-if="seenBefore" :type="seenBefore.tone" show-icon class="seen-before" closable @close="seenBefore = null">
        <span slot="message">{{ seenBefore.title }}</span>
        <div slot="description" class="seen-before-body">
          <div>{{ seenBefore.description }}</div>
          <div v-if="seenBefore.changes && seenBefore.changes.length" class="changes">
            <span v-for="change in seenBefore.changes" :key="change.component" class="change">
              {{ change.component }} {{ change.was }} → {{ change.now }}
            </span>
          </div>
          <div class="seen-before-actions">
            <a-button v-if="seenBefore.downloadable" size="small" type="primary" icon="download"
              :loading="downloadingExisting" @click="downloadExisting">Download the existing model</a-button>
            <span class="matched-note">Matched by the file's content — the name does not matter.</span>
          </div>
        </div>
      </a-alert>

      <a-upload-dragger :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
        <div v-if="fileList.length">
          <a-button type="primary" :loading="uploading" style="margin: 27px" @click.stop.prevent="handleUpload">{{
            uploading ? 'Uploading' : 'Start Upload' }}</a-button>
          <div @click.stop>
            <a-checkbox v-model="enableFormulaCheck">Enable Check Supported Functions script</a-checkbox>
            <a-checkbox v-model="saveRawFile">Save raw file</a-checkbox>
          </div>
        </div>

        <template v-else>
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p class="ant-upload-hint">
            Only *.xlsx or *.xlsm file formats are accepted
          </p>
        </template>
      </a-upload-dragger>
    </template>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import logger from "@/components/log";
import packageInfo from '../../package.json';
import { sha256Hex } from '../utils/sha256';

export default {
  components: {
    logger,
  },

  data() {
    return {
      isShowDownloadBtn: false,
      enableFormulaCheck: true,
      saveRawFile: false,
      processingMsg: null,
      logData: "",
      fileList: [],
      uploading: false,
      isModalVisible: false,
      engineInfo: 'def value',
      seenBefore: null,
      downloadingExisting: false,
    };
  },
  methods: {
    ...mapActions("process", ["initProcess"]),

    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    async downloadModel() {
      await this.downloadModelAt(this.modelPath);
    },

    // Download a model.json from the archive by its storage path (<processId>/model.json)
    async downloadModelAt(path) {
      const { data } = await this.$http.get('/api/process/download', {
        params: { path },
        responseType: 'blob',
        headers: {
          Authorization: this.$store.state.auth.token
        }
      })

      const url = window.URL.createObjectURL(data);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // the filename you want
      a.download = 'model.json';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },

    async downloadExisting() {
      if (!this.seenBefore || !this.seenBefore.processId) return;
      this.downloadingExisting = true;
      try {
        await this.downloadModelAt(`${this.seenBefore.processId}/model.json`);
      } catch (error) {
        console.error(error);
        this.$message.error('Could not download the existing model');
      } finally {
        this.downloadingExisting = false;
      }
    },

    endHandler(path) {
      this.modelPath = path;
      this.isShowDownloadBtn = true;
      this.processingMsg();
      this.$message.success('Completed')
    },

    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      this.checkSeenBefore(file);
      return false;
    },

    // Provenance ledger lookup by the workbook's content hash: the same bytes
    // under any filename were converted before → say so before re-converting
    async checkSeenBefore(file) {
      this.seenBefore = null;
      if (!file.arrayBuffer) return;
      try {
        const sha256 = await sha256Hex(await file.arrayBuffer());
        const { data } = await this.$http.get(`/api/process/provenance/source/${sha256}`, {
          headers: { Authorization: this.$store.state.auth.token },
        });
        const processes = data.processes || [];
        if (!processes.length) return;
        this.seenBefore = this.describeSeenBefore(processes, data.current);
      } catch (error) {
        console.error(error);
      }
    },
    async handleUpload() {
      const { enableFormulaCheck, saveRawFile, fileList } = this;
      const formData = new FormData();

      fileList.forEach((file) => {
        formData.append("models", file);
      });

      formData.append("enableFormulaCheck", enableFormulaCheck);
      formData.append("saveRawFile", saveRawFile);

      this.uploading = true;
      await this.initProcess(formData);
      this.processingMsg = this.$message.loading('Action in progress..', 0);
      this.fileList = [];
      // this.uploading = false;
    },
    // The banner answers one question: will converting again produce anything new?
    // The server compares the stored conversion's pipeline with the one that runs now.
    describeSeenBefore(processes, current) {
      const last = processes[0];
      const count = processes.length === 1 ? 'once' : `${processes.length} times`;
      const when = new Date(last.convertedAt || last.dateCreated).toLocaleString();
      const where = `last as "${last.name}" on ${when}`;
      const changes = last.pipelineChanges;

      if (Array.isArray(changes) && changes.length === 0) {
        return {
          tone: 'info',
          title: `Already converted with the current pipeline — ${where}`,
          description: 'Converting again would produce an identical model. Download the existing one instead, or upload anyway.',
          changes: [],
          processId: last.processId,
          downloadable: true,
        };
      }
      if (Array.isArray(changes)) {
        return {
          tone: 'warning',
          title: `Converted ${count} before, ${where} — the pipeline has changed since`,
          description: 'Converting again applies these changes; the ledger will then show whether the model content differs.',
          changes,
          processId: last.processId,
          downloadable: false,
        };
      }
      return {
        tone: 'warning',
        title: `Converted ${count} before, ${where}`,
        description: current
          ? 'That conversion predates provenance tracking, so its pipeline is unknown and has certainly changed since. Converting again produces a stamped model.'
          : 'The current pipeline could not be checked (extractor unavailable), so it is unknown whether converting again changes anything.',
        changes: [],
        processId: last.processId,
        downloadable: false,
      };
    },

    showModal() {
      this.fetchEngineInfo();
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async fetchEngineInfo() {
      try {
        const { data } = await this.$http.get('/api/extractorInfo/engine-info', {
          headers: {
            Authorization: this.$store.state.auth.token
          }
        })
        this.engineInfo = data;
        this.engineInfo.uiVersion = packageInfo.version;
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.fetchEngineInfo();
  },
};
</script>

<style lang="scss" scoped>
.converter {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  overflow: auto;

  .download-btn {
    flex-shrink: 0;
  }

  .seen-before {
    margin-bottom: 12px;
  }
  .seen-before-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-weight: 400;
  }
  .changes {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 14px;
    font-family: "SFMono-Regular", Menlo, Consolas, monospace;
    font-size: 12px;
  }
  .change {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 2px 8px;
  }
  .seen-before-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .matched-note {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
  }

  .formula-btn {
    background-color: transparent;
    border: none;
    color: transparent;
    cursor: pointer;
    align-self: flex-end;   // right-aligned, but only as wide as the icon
    width: auto;
    padding: 0;
    line-height: 1;
  }

  /* margin: 19px; */
}

.material-symbols-outlined {
  color: #222377;
  font-size: 34px;
  /* Larger size */
  vertical-align: middle;
}
</style>